export default import.meta.ROLLDOWN_FILE_URL_gOpBNSELCNdnM_yZlyA5OQ